import React, { useMemo, useReducer, useEffect, useState } from "react"
import { get } from "lodash"
import uuid from "uuid"
import { withRouter } from "react-router"

import { SummaryTemplate } from "components/templates/summary"
import {
  foreignReducerState,
  useGetSymbolDetailData,
  useRequestForeignIndex,
} from "components/actions/foreign"
import { tableColumns } from "config/table_columns"
import { checkIsSp } from "utils/util"

export const foreignSummaryTableist = [
  {
    id: 0,
    name: "指数",
    api: "FC.Summary.Index",
    list: tableColumns.foreign.index,
  },
  {
    id: 1,
    name: "為替",
    api: "Top.FX.JPY",
    list: tableColumns.index.currencySummary,
  },
]

export const ForeignSummary = withRouter(({ location }) => {
  const [refreshFlag, setRefreshFlag] = useState(false)
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const canvasId = useMemo(() => {
    return uuid()
  }, [])
  const [changeTabFlag, setChangeTabFlag] = useState(false)
  const [state, action] = useReducer(foreignReducerState, {
    selectedSymbol: 0,
    displayType: 0,
  })
  const foreignIndexData = useRequestForeignIndex(
    state.displayType,
    refreshFlag,
    setRefreshFlag
  )
  const [symbolData, setSymbolData] = useGetSymbolDetailData(
    canvasId,
    changeTabFlag,
    setChangeTabFlag
  )

  useEffect(() => {
    if (!!foreignIndexData) {
      const resultList = get(foreignIndexData, "ResultList", [])
      !isPhone && setSymbolData(resultList[state.selectedSymbol])
    }
  }, [foreignIndexData])

  return (
    <SummaryTemplate
      state={state}
      action={action}
      foreignIndexData={foreignIndexData}
      canvasId={canvasId}
      symbolData={symbolData}
      setSymbolData={setSymbolData}
      setRefreshFlag={setRefreshFlag}
    />
  )
})
